module.exports = "<svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" xmlns=\"http://www.w3.org/2000/svg\"><title>Rectangle 15 Copy</title><path d=\"M2.818 3.94A1.5 1.5 0 1 0 .697 6.06l4.242 4.243L6 11.364l1.06-1.06 7.122-7.122a1.5 1.5 0 0 0-2.121-2.121L6 7 2.818 3.94z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/success.svg
// module id = 888
// module chunks = 0